if (!customElements.get('nmt-product-demo')) {
  customElements.define('nmt-product-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.opener = this.querySelector('[data-demo-open]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.opener.addEventListener('click', (event) => {
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('nmt-demo-open');
        const source = this.video.querySelector('source');
        if (!source.hasAttribute('src')) {
          source.src = source.dataset.src;
          this.video.load();
        } else if (this.video.readyState) {
          this.video.currentTime = 0;
        }
        this.video.play().catch(() => {}); // Native controls remain available if play is deferred.
      }, options);
      this.querySelector('[data-demo-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.video.pause();
        this.releaseScroll();
        if (this.opener.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.video.addEventListener('error', () => {
        this.querySelector('[data-demo-error]').hidden = false;
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
      }, options);
    }
    releaseScroll() {
      if (!document.querySelector('nmt-product-demo dialog[open]')) document.documentElement.classList.remove('nmt-demo-open');
    }
    disconnectedCallback() {
      this.video?.pause();
      this.events?.abort();
      this.events = null;
      this.releaseScroll();
    }
  });
}
